import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { fetchHorizonResources } from './operationsSlice'
import { HORIZON_STATE_COLORS } from './types/operations.types'
import { OperationsTabBar } from './components/OperationsTabBar'
import { HorizonLane } from './components/HorizonLane'
import {
  OpsPageWrapper,
  OpsCard,
  OpsCardHeader,
  HorizonHeader,
  HorizonLegend,
  LegendItem,
  HorizonGrid,
  opsColors,
} from './styled/Operations.styled'
import { NavBar } from 'components/NavBar/NavBar'

export const RollingHorizonBoard: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>()
  const { horizonResources } = useSelector((state: RootState) => state.operations)

  useEffect(() => {
    dispatch(fetchHorizonResources())
  }, [dispatch])

  return (
    <>
      <NavBar />

      <OpsPageWrapper>
        <h1 style={{ fontSize: '30px', fontWeight: 900, color: opsColors.textPrimary, margin: 0, fontFamily: 'DM Sans, sans-serif' }}>
          Rolling Horizon
        </h1>

        <OperationsTabBar />

        <OpsCard>
          <HorizonHeader>
            <div>
              <h3 style={{ fontSize: '18px', fontWeight: 800, color: opsColors.textPrimary, margin: '0 0 0.25rem 0' }}>
                6-Hour Horizon
              </h3>
              <span style={{ fontSize: '12px', color: opsColors.textFaded }}>14:00 - 20:00</span>
            </div>
            <HorizonLegend>
              <LegendItem color={HORIZON_STATE_COLORS.inProgress.bg}>In Progress</LegendItem>
              <LegendItem color={HORIZON_STATE_COLORS.assigned.bg}>Assigned</LegendItem>
              <LegendItem color={HORIZON_STATE_COLORS.proposed.bg}>Proposed</LegendItem>
              <LegendItem color={HORIZON_STATE_COLORS.blocked.bg}>Blocked</LegendItem>
            </HorizonLegend>
          </HorizonHeader>

          {/* Time axis */}
          <div style={{ display: 'grid', gridTemplateColumns: '120px 1fr', gap: '0.75rem', marginBottom: '0.75rem' }}>
            <div />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              {['14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00'].map((t) => (
                <span key={t} style={{ fontSize: '10px', color: opsColors.textFaded }}>{t}</span>
              ))}
            </div>
          </div>

          <HorizonGrid>
            {horizonResources?.map((resource) => (
              <HorizonLane key={resource.id} resource={resource} />
            ))}
          </HorizonGrid>
        </OpsCard>
      </OpsPageWrapper>
    </>
  )
}
